export const checkIfFileIsImage = (file: File) => {
  return file.type.split('/').includes('image');
};

export const checkIfFileIsVideo = (file: File) => {
  return file.type.split('/').includes('video');
};
